import { data } from "./upgrade.data";

export {
    data
}